export const defaultNoRacesContent = {
  title: "No races available",
  description:
    "There are no races happening at this time. This is not that common, please check back later."
};
